import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { YincanaComponent } from '../yincana-ar/yincana-ar.component';

@Component({
  selector: 'app-evento-yincana',
  templateUrl: './evento-yincana.component.html',
  styleUrls: ['./evento-yincana.component.scss'],
})
export class EventoYincanaComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoYincanaComponent>
  ) {}

  ngOnInit(): void {}

  openYincanaModal() {
    const dialogRef = this.dialog.open(YincanaComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }
}